let platform;
let platforms;
let platformsDuplicates = 1;

function customScroll(scrollLeft) {
    const scrollSpeed = 10;
    const scrollValue = Math.min(Math.max(-scrollSpeed, scrollLeft), scrollSpeed)

    if (scrollValue != 0) {
        platform.scroll({
            top: 0,
            left: platform.scrollLeft + scrollValue
        })

        setTimeout(() => customScroll(scrollLeft - scrollValue), 1);
    }
}

function diffToPlatformCenter(element) {
    const platformX = platform.getBoundingClientRect().x;
    const platformWidth = platform.getBoundingClientRect().width;
    const elementX = element.getBoundingClientRect().x;
    const elementWidth = element.getBoundingClientRect().width;
    const toEdgeScroll = platform.scrollLeft + elementX;

    const desiredScroll = (toEdgeScroll) - (platformWidth / 2) + (elementWidth / 2) - platformX
    const scrollDiff = desiredScroll - platform.scrollLeft;

    return scrollDiff;
}

function scrollToPlatform(element) {
    const scrollDiff = diffToPlatformCenter(element)
    customScroll(scrollDiff);
}

function adjustPlatform() {
    const duplicateLength = platform.scrollWidth / (2 * platformsDuplicates + 1);

    if (platform.scrollLeft > duplicateLength * (platformsDuplicates + 1)) {
        platform.scrollLeft = platform.scrollLeft - duplicateLength;
    }

    if (platform.scrollLeft < duplicateLength * (platformsDuplicates)) {
        platform.scrollLeft = platform.scrollLeft + duplicateLength;
    }

    // Resize items
    platforms.forEach(element => {
        const diff = Math.abs(diffToPlatformCenter(element));
        const platformSide = platform.getBoundingClientRect().width / 2;

        // Normalize - 1 is close 0 is far
        const normalized = Math.max(0, 1 - (diff / platformSide))
        const scale = (0.5 + (normalized * 0.8)).toFixed(2);;

        element.querySelector('img').style.transform = `scale(${scale})`
    })
}

window.addEventListener("load", () => {
    platform = document.getElementById("platforms-scroll");
    if (!platform) return;
    
    const platformsList = document.getElementById("platforms-list");
    platforms = platform.querySelectorAll('.platform');

    // Clone nodes
    for (let i = 0; i < platformsDuplicates * 2; i++) {
        platforms.forEach(element => {
            const clone = element.cloneNode(true);
            platformsList.append(clone)
        })
    }
    

    platforms = platform.querySelectorAll('.platform');
    

    adjustPlatform();

    platformListener = platform.addEventListener('scroll', () => {
        adjustPlatform();
    });
});